(function () {
  "use strict";

  CourseEmailsCtrl.$inject = ['$scope', '$routeParams', 'resolveData', '$rootScope', '$location', 'Validation', 'textLengthIndicatorState', 'CustomEmailResource', 'CustomizeResource', 'mtypes', '$sce', '$window'];
  angular
    .module('trainerWebApp.controllers')
    .controller('CourseEmailsCtrl', CourseEmailsCtrl);

  function CourseEmailsCtrl($scope, $routeParams, resolveData, $rootScope, $location, Validation, textLengthIndicatorState,
                            CustomEmailResource, CustomizeResource, mtypes, $sce, $window) {

    $window.document.title = "Course | Mindflash Training Management System";

    if (!resolveData) return;

    $scope.courseId = $routeParams.courseId;
    var acc = ['0', '1', '2'].indexOf($routeParams.acc) == -1 ? 0 : $routeParams.acc;

    var maxCustomTextLength = 1000;

    $scope.modal = {
      content: "Loading"
    };

    // If server sends back none mtype then use default of 3 days to start.
    if (resolveData.reminderSettings.reminderInterval == mtypes.reminderInterval.none)
      resolveData.reminderSettings.reminderInterval = mtypes.reminderInterval.threeDays;

    $scope.reminderSettings = {
      reminderActive: resolveData.reminderSettings.reminderActive == 1,
      reminderInterval: resolveData.reminderSettings.reminderInterval
    };

    $scope.panes = [
      {
        name: 'Invitation',
        text: $sce.trustAsHtml(resolveData.invitation.text),
        customText: $('<div/>').html(resolveData.invitation.customText).text(),
        showInfo: false,
        open: true
      },
      {
        name: 'Reminder',
        text: $sce.trustAsHtml(resolveData.reminder.text),
        customText: $('<div/>').html(resolveData.reminder.customText).text(),
        showInfo: true,
        open: false
      },
      {
        name: 'Completion',
        text: $sce.trustAsHtml(resolveData.completion.text),
        customText: $('<div/>').html(resolveData.completion.customText).text(),
        showInfo: false,
        open: false
      }
    ];

    _.each($scope.panes, function (pane) {
      pane.disableAction = true;
      pane.reminderSettingsChanged = false;
      pane.customTextChanged = false;
      pane.title = pane.name + ' Email';
      resolveData[pane.name.toLowerCase()].customText = pane.customText;
    });

    var timer = setTimeout(function () {
      angular.element('#collapse' + acc).addClass('in');
    }, 1);

    $scope.saveData = function (pane) {
      saveCustomEmail(pane);
      saveReminderSettings(pane);
    };

    function saveCustomEmail(pane) {
      if (!pane.customTextChanged)
        return;
      pane.customTextChanged = false;
      CustomEmailResource['updateCourse' + pane.name]($scope.courseId, pane.customText, function (result) {
        resolveData[pane.name.toLowerCase()].customText = pane.customText;
        pane.disableAction = true;
        courseDescriptionChange(pane, '');
      }, function (error) {
        pane.disableAction = true;
      });
    }

    function saveReminderSettings(pane) {
      if (!pane.reminderSettingsChanged)
        return;
      pane.reminderSettingsChanged = false;
      CustomizeResource.updateCourseReminderSettings($scope.courseId, $scope.reminderSettings.reminderActive, $scope.reminderSettings.reminderInterval, function (result) {
        pane.disableAction = true;
        resolveData.reminderSettings.reminderActive = $scope.reminderSettings.reminderActive;
        resolveData.reminderSettings.reminderInterval = $scope.reminderSettings.reminderInterval;
      }, function (error) {
        pane.disableAction = true;
      });
    }

    $scope.resetCustomEmail = function (pane) {
      pane.customText = resolveData[pane.name.toLowerCase()].customText;
      pane.disableAction = true;
      pane.reminderSettingsChanged = false;
      pane.customTextChanged = false;
      resetReminderSettings(pane);
      courseDescriptionChange(pane, pane.customText);
    };

    $scope.taChange = function (pane) {
      pane.customTextChanged = true;
      pane.disableAction = false;
      courseDescriptionChange(pane, pane.customText);
    };

    function courseDescriptionChange(pane, customText) {
      var state = textLengthIndicatorState.getState(customText, maxCustomTextLength);
      pane.courseDescriptionIndicatorStyle = state.style;
      pane.courseDescriptionIndicatorText = state.text;
      pane.formValid = state.lengthValid;
    }

    function resetReminderSettings(pane) {
      if (pane.name != 'Reminder')
        return;

      $scope.reminderSettings = {
        reminderActive: resolveData.reminderSettings.reminderActive == 1,
        reminderInterval: resolveData.reminderSettings.reminderInterval
      };
    }

    $scope.previewEmail = function (pane) {
      CustomEmailResource['previewCourse' + pane.name]($scope.courseId, pane.customText).$promise.then(function (result) {
        $scope.modal.content = {};
        $scope.modal.content.text = $sce.trustAsHtml(result.text);
      });
    };

    $scope.reminderSettingsChange = function (pane) {
      if (pane.name != 'Reminder') return;
      pane.disableAction = false;
      pane.reminderSettingsChanged = true;
      courseDescriptionChange(pane, pane.customText);
    };

    $scope.reminderIntervals = [
      {
        text: '3 days',
        mtype: mtypes.reminderInterval.threeDays
      },
      {
        text: '7 days',
        mtype: mtypes.reminderInterval.oneWeek
      },
      {
        text: '14 days',
        mtype: mtypes.reminderInterval.twoWeeks
      }
    ];

    // Validation
    Validation.addValidation(validate);

    var nextLocation;
    var continueNavigation = false;

    function validate() {
      var retVal = [];
      angular.forEach($scope.panes, function (pane) {
        if (pane.customText != resolveData[pane.name.toLowerCase()].customText)
          this.push(pane);
      }, retVal);

      if (_.isEmpty(retVal)) {
        Validation.removeValidation(validate);
        return true;
      }

      nextLocation = $rootScope.newLocation.next;
      angular.element("#save-email-modal").modal("show");
      return false;
    }

    angular.element("#save-email-modal").on('hidden', function () {
      if (!continueNavigation)
        return;
      Validation.removeValidation(validate);
      $location.path(nextLocation.path).search(nextLocation.search);
      $rootScope.$apply();
    });

    $scope.continueNavigation = function () {
      continueNavigation = true;
    };


    $scope.$on('$destroy', function () {
      Validation.removeValidation(validate);
      clearTimeout(timer);
      $scope.modal = null;
      angular.element("#save-email-modal").off();
    });

    $scope.getArrowClass = function (pane) {
      return pane.open ? "accordion-section-indicator accordion-section-indicator-desc" : "accordion-section-indicator accordion-section-indicator-asc";
    }
  }

})();
